import { type FC } from "react";
import CheckCircle from "@mui/icons-material/CheckCircle";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";

export const SignedOutPage: FC = () => (
  <InfoPageLayout>
    <InfoPage
      title="Вы вышли из EkoCrop"
      message="Чтобы продолжить работу, войдите снова"
      illustration={<InfoPageIllustration icon={CheckCircle} />}
      actions={<SignInButton label="Войти" />}
    />
  </InfoPageLayout>
);
